import React from 'react';
import { Link } from 'react-router-dom';

function HomePage() {
    const devMode = process.env.REACT_APP_DEVELOPER_MODE;

    return (
        <div class="bg-white">
            <div class="mx-auto max-w-7xl py-24 sm:px-6 sm:py-32 lg:px-8">
                <div class="relative isolate overflow-hidden bg-gray-900 px-6 pt-16 shadow-2xl sm:rounded-3xl sm:px-16 md:pt-24 lg:flex lg:gap-x-20 lg:px-24 lg:pt-0">
                    <svg viewBox="0 0 1024 1024" class="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-y-1/2 [mask-image:radial-gradient(closest-side,white,transparent)] sm:left-full sm:-ml-80 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2 lg:translate-y-0" aria-hidden="true">
                        <circle cx="512" cy="512" r="512" fill="url(#759c1415-0410-454c-8f7c-9a820de03641)" fill-opacity="0.7" />
                        <defs>
                            <radialGradient id="759c1415-0410-454c-8f7c-9a820de03641">
                                <stop stop-color="#7775D6" />
                                <stop offset="1" stop-color="#E935C1" />
                            </radialGradient>
                        </defs>
                    </svg>
                    <div class="mx-auto max-w-md text-center lg:mx-0 lg:flex-auto lg:py-32 lg:text-left text-white">
                        {
                            devMode === "Y"
                            ?
                                <nav class="mb-4">
                                    <ul>
                                        <li><Link to="/makepayment/<transactionid>">Make Payment</Link></li>
                                        <li><Link to="/paymentcomplete">Payment Complete</Link></li>
                                    </ul>
                                </nav>
                            :
                            <span></span>
                        }
                        <h2 class="text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl">Kickstart your health with Healthblocks</h2>
                        <p class="mt-6 text-pretty text-lg/8 text-gray-300">A data driven, community inspired health application that handles data and value distribution the right way.</p>
                        <div class="mt-10 flex items-center justify-center gap-x-6 lg:justify-start">
                            <a href="https://healthblocks.ai" class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">Tell me more</a>
                        </div>
                    </div>
                    <div class="relative mt-16 h-80 lg:mt-8">
                        <img class="" src="/hbapp-activities.png" alt="Healthblocks Activities" ></img>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePage;
